import { useMutation, useQuery } from "@apollo/client";
import { IMeetingTypeEntity } from "./MeetingTypeEntityInterfaces";
import { useState } from "react";
import {
    deleteMeetingTypeAndUpdateRegistries,
    getMeetingTypes,
    getMeetingTypesReturn,
    getValidateMeetingIsUsedReturn,
    insertMeetingType,
    updateMeetingType,
    validateMeetingIsUsed,
} from "api/queries/RCA/RCALibraryAPI";

export const MeetingTypeEntity: IMeetingTypeEntity = {
    GetMeetingTypes: (filterOutId?: number) => {
        const [meetingTypes, setMeetingTypes] = useState<getMeetingTypesReturn["meeting_type"]>([]);

        const { loading, error, refetch } = useQuery(getMeetingTypes, {
            variables: {
                where: {
                    ...(filterOutId && { id: { _neq: filterOutId } }),
                    deleted_at: { _is_null: true },
                },
            },
            onCompleted: (data: getMeetingTypesReturn) => {
                setMeetingTypes(data.meeting_type);
            },
        });

        return {
            loading,
            meetingTypes,
            apolloQueryError: error,
            refetch,
        };
    },
    ValidateMeetingTypeIsUsed: (id: number) => {
        const [isUsed, setIsUsed] = useState<boolean | undefined>(false);

        const { loading, error } = useQuery(validateMeetingIsUsed, {
            fetchPolicy: "no-cache",
            variables: {
                where: {
                    id: { _eq: id },
                },
            },
            onCompleted: (data: getValidateMeetingIsUsedReturn) => {
                const validateUse = !!(
                    data.meeting_type[0].action_plans.length ||
                    data.meeting_type[0].issues.length ||
                    data.meeting_type[0].rcas.length
                );
                setIsUsed(validateUse);
            },
        });

        return {
            loading,
            isUsed,
            apolloQueryError: error,
        };
    },
    InsertMeetingType: () => {
        const [addMeetingType, { error }] = useMutation(insertMeetingType);

        return { apolloMutationError: error, addMeetingType };
    },
    UpdateMeetingType: () => {
        const [changeMeetingType, { error }] = useMutation(updateMeetingType);

        return { apolloMutationError: error, changeMeetingType };
    },
    DeleteMeetingTypeAndUpdateRegistries: () => {
        const [deleteAndUpdateRegistries, { error }] = useMutation(deleteMeetingTypeAndUpdateRegistries);

        return { apolloMutationError: error, deleteAndUpdateRegistries };
    },
};
